<template>
  <cus-dialog-in-dialog>
    <template v-slot:body>
      <div class="computer">
        <!-- 顯示欄位 -->
        <div class="compute-number">
          <cus-button
            :color="selectTime === 'AM' ? 'green' : 'gray'"
            text="AM"
            buttonClass="num-icon"
            @click="selectTime = 'AM'"
          ></cus-button>
          <p class="result">{{ computeNum.slice(0, 2) }}：{{ computeNum.slice(2) }}</p>
          <cus-button
            :color="selectTime === 'PM' ? 'green' : 'gray'"
            text="PM"
            buttonClass="num-icon"
            @click="selectTime = 'PM'"
          ></cus-button>
        </div>
        <!-- 數字鍵 -->
        <div class="number-button">
          <cus-button
            v-for="num in 9"
            :key="num"
            :text="num.toString()"
            @click="handleNumber(num)"
            :disabled="key === 4"
          ></cus-button>
          <cus-button text="0" style="grid-area: 4/1/5/3" @click="handleNumber(0)" :disabled="key === 4"></cus-button>
          <cus-button
            topIcon="arrow-left"
            topIconClass="back-arrow"
            @click="handleBack"
            :disabled="back === 4"
          ></cus-button>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button text="確認" color="blue" :width="50" @click="changeTime" :disabled="checkTime()"></cus-button>
      </div>
    </template>
  </cus-dialog-in-dialog>
</template>
<script>
import { ref, inject } from 'vue';
export default {
  name: 'time-picker',
  setup() {
    //接受provide值
    const dialogVisible = inject('inner_dialogVisible', false);
    const close = inject('inner_close');
    const submit = inject('inner_submit');
    //設定參數
    const computeNum = ref('0000'); //顯示數值
    const key = ref(0);
    const back = ref(4);
    const hour = new Date().getHours();
    const selectTime = ref('AM');
    if (dialogVisible) {
      computeNum.value = '0000';
      key.value = 0;
      back.value = 4;
      if (Number(hour) >= 12) selectTime.value = 'PM';
    }

    //按數字
    const handleNumber = (num) => {
      if (computeNum.value === '0000' && num === 0) return;
      computeNum.value = computeNum.value.slice(1) + num;
      key.value += 1;
      back.value -= 1;
    };
    //消除數字
    const handleBack = () => {
      computeNum.value = 0 + computeNum.value.slice(0, 3);
      key.value -= 1;
      back.value += 1;
    };
    //12/24小時制轉換
    const changeTime = () => {
      const hour = Number(computeNum.value.slice(0, 2));
      let time;
      if (selectTime.value === 'PM' && hour < 12) {
        time = hour + 12 + ':' + computeNum.value.slice(2);
      } else {
        time = computeNum.value.slice(0, 2) + ':' + computeNum.value.slice(2);
      }
      submit(time);
    };
    //檢查輸入
    const checkTime = () => {
      if (
        Number(computeNum.value.slice(0, 2)) === 0 ||
        Number(computeNum.value.slice(0, 2)) > 23 ||
        Number(computeNum.value.slice(2)) > 59
      )
        return true;
      else if (selectTime.value === 'AM' && Number(computeNum.value.slice(0, 2)) <= 6) return true;
      return false;
    };
    return {
      close,
      computeNum,
      key,
      back,
      selectTime,
      handleNumber,
      handleBack,
      changeTime,
      checkTime,
    };
  },
};
</script>
<style lang="scss" scoped>
.computer {
  @include computer-basic;
}
</style>
